import { createStoreChunk } from '@core/store'

export type TGiftRecipient = {
    avatarUrl: string
    username: string
    audioId: string
    authorId: string
}

type TGiftState = {
    recipient: TGiftRecipient | null
    queuedRecipient: TGiftRecipient | null
    hasSeenGiftOffer: boolean
}

export const giftStore = createStoreChunk<TGiftState>('gift')({
    persist: { sessionStorage: ['hasSeenGiftOffer'] },
    initialState: {
        recipient: null,
        queuedRecipient: null,
        hasSeenGiftOffer: false,
    },
    actions: {
        markGiftOfferSeen: () => ({ hasSeenGiftOffer: true }),
        queueGift: (queuedRecipient: TGiftRecipient) => ({ queuedRecipient }),
        clearQueuedGift: () => ({ queuedRecipient: null }),
    },
})
